function isValidIpv4(value: string): boolean {
  const parts = value.split(".");
  if (parts.length !== 4) {
    return false;
  }

  return parts.every((part) => {
    if (!/^\d+$/.test(part)) {
      return false;
    }
    const octet = Number(part);
    return octet >= 0 && octet <= 255;
  });
}

function isValidIpv6(value: string): boolean {
  const normalized = value.toLowerCase();
  if (!/^[0-9a-f:]+$/.test(normalized)) {
    return false;
  }

  const segments = normalized.split(":");
  if (segments.length < 3 || segments.length > 8) {
    return false;
  }

  let emptyRun = 0;
  for (const segment of segments) {
    if (segment === "") {
      emptyRun += 1;
      continue;
    }
    if (segment.length > 4 || !/^[0-9a-f]+$/.test(segment)) {
      return false;
    }
  }

  return emptyRun <= 1;
}

export function isAllowedIpOrCidr(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed === "") {
    return false;
  }

  const slashIndex = trimmed.indexOf("/");
  if (slashIndex === -1) {
    return isValidIpv4(trimmed) || isValidIpv6(trimmed);
  }

  const ipPart = trimmed.slice(0, slashIndex);
  const prefixPart = trimmed.slice(slashIndex + 1);
  if (!/^\d+$/.test(prefixPart)) {
    return false;
  }

  const prefix = Number(prefixPart);
  if (isValidIpv4(ipPart)) {
    return prefix >= 0 && prefix <= 32;
  }
  if (isValidIpv6(ipPart)) {
    return prefix >= 0 && prefix <= 128;
  }

  return false;
}

export function normalizeAllowedIps(values: string[]): string[] {
  const normalized: string[] = [];
  const seen = new Set<string>();

  for (const value of values) {
    const trimmed = value.trim();
    if (trimmed === "" || seen.has(trimmed)) {
      continue;
    }
    seen.add(trimmed);
    normalized.push(trimmed);
  }

  return normalized;
}
